// extracted by mini-css-extract-plugin
module.exports = {"cancel":"MyArea_cancel__P4oxz","close":"MyArea_close__XvRVp"};